/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ApiRequestOptions } from './ApiRequestOptions';

type Resolver<T> = (options: ApiRequestOptions) => Promise<T>;
type Headers = Record<string, string>;

export type OpenAPIConfig = {
    BASE: string;
    VERSION: string;
    WITH_CREDENTIALS: boolean;
    CREDENTIALS: 'include' | 'omit' | 'same-origin';
    TOKEN?: string | Resolver<string> | undefined;
    USERNAME?: string | Resolver<string> | undefined;
    PASSWORD?: string | Resolver<string> | undefined;
    HEADERS?: Headers | Resolver<Headers> | undefined;
    ENCODE_PATH?: ((path: string) => string) | undefined;
};

export const OpenAPI: OpenAPIConfig = {
    //NOTE: this config makes running on local machine easier
    // REACT_APP_API_BASE takes a full URL, so a local backend can be targeted
    // directly (http://localhost:3000). REACT_APP_ROOT_DOMAIN only ever yields
    // https://connect.<domain>, which cannot express that.
    BASE: process.env.REACT_APP_API_BASE
        || (process.env.REACT_APP_ROOT_DOMAIN ? `https://connect.${process.env.REACT_APP_ROOT_DOMAIN}` : 'https://connect.weberlo.com'),
    VERSION: '1.0.0',
    WITH_CREDENTIALS: false,
    CREDENTIALS: 'include',
    TOKEN: undefined,
    USERNAME: undefined,
    PASSWORD: undefined,
    HEADERS: undefined,
    ENCODE_PATH: undefined,
};
